import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddDesignation(){
    const [dept, setdept] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [deptData,setdeptData]=useState({
        "designation":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        setdeptData({
            ...deptData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('designation',deptData.designation);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'add-designation/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Designation Added Successfully',
                        icon: 'success',
                        timer:8001,
                        showConfirmButton: false
                    });
                setTimeout(() => {
                  window.location.href = '/add-designation/';
                }, 3000);
               }
            });
            }catch(error){
                console.log(error);
            }
        };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (dept.length > 0) {
        setRows(dept);
      }
  }, [dept]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}add-designation/`)
      .then(response => {
        setdept(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-designation/'+id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                        window.location.href = '/add-designation/';
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 160 },
    { field: 'designation', headerName: 'Designation', width: 500 },
    { field: 'addedby', headerName: 'Added By', width: 200},
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];

    return (
        <section className="container mt-4">
            <div className="row">

              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Designation</h4>
                    <div className='card-body'>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="designation" className="form-label">Designation</label>
                            <input type="text" className="form-control" name="designation" value={deptData.designation}
                            onChange={handleChange} id="designation" />
                          </div>

                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>


        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default AddDesignation;